module.exports = __webpack_public_path__ + "img/sign.c9db6850.png";